import type { ITexts, TAliases, TGeoGroups, TTopCities } from './models';

export const DEFAULT_GEO_GROUPS: TGeoGroups = ['sme', 'remote'];
export const DEFAULT_TOP_CITIES: TTopCities = [
    '0c5b2444-70a0-4932-980c-b4dc0d3f02b5', // Москва
    'c2deb16a-0330-4f05-821f-1d09c93331e6', // Питер
    '2763c110-cb8b-416a-9dac-ad28a55b4402', // Ёбург
    '8dea00e3-9aab-4d8e-887c-ef2aaa546456', // Новосиб
    'c1cfe4b9-f7c2-423c-abfa-6ed1c05a15c5', // Ростов-На-Дону
];
export const DEFAULT_ALIASES: TAliases = {};
export const DEFAULT_CITY_ICONS = {};

export const DEFAULT_DESKTOP_TEXTS: ITexts = {
    emptyText: 'Нас здесь пока нет',
    searchPlaceholder: 'Введите название города',
    titleWhileSearch: 'Сейчас:',
    titleForHeader: 'Вы здесь:',
    topCitiesHeader: 'Популярные города',
};

export const DEFAULT_MOBILE_TEXTS: ITexts = {
    ...DEFAULT_DESKTOP_TEXTS,
    titleForHeader: 'Выбор города',
};

export const EVENTS = [
    {
        name: 'show_cities_popup',
        propKeys: [
            {
                dataKey: 'actionCreatedBy',
                propKey: 'emittedBy',
            },
            {
                dataKey: 'show',
                propKey: 'open',
            },
            {
                dataKey: 'geo',
                propKey: 'geo',
            },
        ],
    },
];

export const MAX_TOP_CITIES = 5;
export const UNKNOWN_FIAS_ID = 'unknown';
